function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "starwars_icons");

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1361.2,1915.6c0,64.7,52.5,117.2,117.2,117.2s117.2-52.5,117.2-117.2s-52.5-117.2-117.2-117.2S1361.2,1850.9,1361.2,1915.6 z M1501.9,1915.6c0,26.3-46.9,26.3-46.9,0c0-12.9,10.5-23.4,23.4-23.4C1491.4,1892.2,1501.9,1902.7,1501.9,1915.6z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1478.4,2424.7c-55.9,0-101.2,45.3-101.2,101.2c0,55.9,45.3,101.2,101.2,101.2c55.9,0,101.2-45.3,101.2-101.2l0,0 C1579.7,2470,1534.4,2424.7,1478.4,2424.7z M1470.9,2525.9c0-4.4,3.6-8,8-8c4.4,0,8,3.6,8,8c-0.9,9.4-15.9,9.4-15.9,0.9V2525.9z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1251.6,2390.9c-55.9,0-101.2,45.3-101.2,101.2s45.3,101.2,101.2,101.2s101.2-45.3,101.2-101.2l0,0 C1352.8,2436.3,1307.5,2390.9,1251.6,2390.9z M1244.1,2492.2c0-4.4,3.6-8,8-8c4.4,0,8,3.6,8,8 C1259.1,2500.6,1244.1,2500.6,1244.1,2492.2z"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1603.1,2492.2c0,55.9,45.3,101.2,101.2,101.2c55.9,0,101.2-45.3,101.2-101.2s-45.3-101.2-101.2-101.2l0,0 C1648.5,2390.9,1603.1,2436.3,1603.1,2492.2z M1696.9,2492.2c0-4.4,3.6-8,8-8c4.4,0,8,3.6,8,8 C1712.8,2500.6,1696.9,2500.6,1696.9,2492.2z"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1478.4,2648.8c-55.9,0-101.2,45.3-101.2,101.2s45.3,101.2,101.2,101.2c55.9,0,101.2-45.3,101.2-101.2l0,0 C1579.7,2694.1,1534.4,2648.8,1478.4,2648.8z M1470.9,2750c0-4.4,3.6-8,8-8c4.4,0,8,3.6,8,8 C1485.9,2758.4,1470.9,2758.4,1470.9,2750z"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1204.7,2615c-55.9,0-101.2,45.3-101.2,101.2c0,55.9,45.3,101.2,101.2,101.2s101.2-45.3,101.2-101.2l0,0 C1305.9,2660.3,1260.6,2615,1204.7,2615z M1197.2,2716.2c0-4.4,3.6-8,8-8c4.4,0,8,3.6,8,8 C1213.1,2724.7,1197.2,2724.7,1197.2,2716.2z"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1650,2716.2c0,55.9,45.3,101.2,101.2,101.2c55.9,0,101.2-45.3,101.2-101.2c0-55.9-45.3-101.2-101.2-101.2l0,0 C1695.3,2615,1650,2660.3,1650,2716.2z M1743.8,2716.2c0-4.4,3.6-8,8-8c4.4,0,8,3.6,8,8C1759.7,2724.7,1743.8,2724.7,1743.8,2716.2z "
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M2505,1016.6c-7.2-17.5-24.2-29-43.1-29.1h-81.6c-19.7,0-37.4,12.4-44.1,30.9l-38.4,109.7c-0.9,5.3-0.9,10.7,0,15.9v75 L1875,231.9c-7.2-17.5-24.2-29-43.1-29.1h-244.7c-25.9,0-46.9,21-46.9,46.9v356.2h-124.7V249.7c0-25.9-21-46.9-46.9-46.9H1125 c-18.9,0.1-35.9,11.6-43.1,29.1L490.3,1625l0,0c-0.3,3.1-0.3,6.3,0,9.4c-0.2,2.8-0.2,5.6,0,8.4c-0.5,4-0.5,8.1,0,12.2 c-0.2,2.2-0.2,4.4,0,6.6c2.1,4.8,4.9,9.3,8.4,13.1l0,0c3.1,3,6.5,5.5,10.3,7.5l167.8,74.1H489.4c-25.9,0-46.9,21-46.9,46.9v218.4 c0,25.9,21,46.9,46.9,46.9h206.2l-180,74.1c-22.1,9.1-33.8,33.3-27.2,56.2c50.1,174.1,145.2,331.9,275.6,457.5l-35.6,41.2 c-17.9,18.2-17.9,47.4,0,65.6c210.7,172.6,472.2,271.4,744.4,281.2c264.1-6.2,518.6-99.9,723.7-266.2c18.9-16.6,21.4-45.1,5.6-64.7 l-33.8-43.1c139.6-126.2,241.7-288.4,295.3-468.8c6.3-22.2-4.4-45.6-25.3-55.3l-161.2-74.1h180c25.9,0,46.9-21,46.9-46.9v-218.4 c0-25.9-21-46.9-46.9-46.9h-188.4l168.8-74.1c23.4-10.3,34.2-37.4,24.4-60.9c-10.3-25.3-22.5-48.8-33.8-73.1l93.8-39.4 c17.1-7.5,28.2-24.4,28.1-43.1v-326.2c1.1-5.9,1.1-11.9,0-17.8L2505,1016.6z M2411.2,1080.3h16.9l28.1,71.3v33.7h-70.3v-34.7 L2411.2,1080.3z M1587.2,1718.8L1587.2,1718.8c107.2,61.9,143.9,198.9,82.1,306.1c-61.9,107.2-198.9,143.9-306.1,82.1 c-107.2-61.9-143.9-198.9-82.1-306.1c40.3-69.8,114.9-112.5,195.4-112.1C1515.4,1689,1553.5,1699.4,1587.2,1718.8z M2195.6,1851.9 v124.7h-404.1c8.4-41.1,8.4-83.6,0-124.7H2195.6z M1726.9,2113.4c10.8-13.6,20.6-28,29.1-43.1h252.2 c-25.1,86.2-70.8,165-133.1,229.7L1726.9,2113.4z M1076.2,2291.6c-59-62.7-102.4-138.6-126.6-221.3h252.2 c8.2,14.8,17.6,28.9,28.1,42.2L1076.2,2291.6z M595.3,1617.5c147.2-335.6,375-544.7,666.6-612.2l-29.1,312.2 c-181.5,75-319.3,228-375,416.3l-263.4-115.3L595.3,1617.5z M1384.7,699.7h187.5l73.1,780h-332.8L1384.7,699.7z M1725,1317.5 l-29.1-314.1c107,23.5,208.1,68.5,297.2,132.2l-195.9,217.5c-23.6-13.4-48-25.3-73.1-35.6H1725z M1026.6,1598.8l179.1,153.8v7.5 H952.5c15.4-57.7,40.1-112.4,73.1-162.2L1026.6,1598.8z M1165.3,1854.7c-8.4,41.1-8.4,83.6,0,124.7h-405v-125.6L1165.3,1854.7z  M1479.4,1596.9c-79.2,0.2-155.4,30-213.8,83.4l-178.1-152.8c38.3-40.5,82.6-74.9,131.2-102.2l-9.4,93.8 c-2.6,25.8,16.2,48.7,42,51.3c1.6,0.2,3.3,0.2,4.9,0.2h436.9l-99.4,46.9c-36.8-14.3-75.9-21.6-115.3-21.6L1479.4,1596.9z  M1732.5,1559.4c8.9-9.6,13.3-22.6,12.2-35.6l-9.4-93.8c43.2,22.8,83.3,51.1,119.1,84.4l-124.7,51.6L1732.5,1559.4z M1947.2,1471.3 c-22.1-23-46-44.3-71.2-63.8l187.5-210.9c54.8,49.6,104.2,104.9,147.2,165L1947.2,1471.3z M1801.9,296.6l367.5,869.1 c-130.7-133.3-298.7-223.9-481.9-259.7l-24.4-257.8c-1.8-16.4-12.2-30.7-27.2-37.5V296.6H1801.9z M1154.1,296.6h167.8v314.1 c-15,6.8-25.4,21.1-27.2,37.5l-24.4,258.8c-183.9,36.2-352.7,126.6-484.7,259.7L1154.1,296.6z M541.9,1853.8h124.7v124.7H541.9 V1853.8z M591.6,2216.6l268.1-109.7c30.3,97.3,83.4,186,154.7,258.8L826.9,2585c-106.5-102.8-187.1-229.4-235.3-369.4L591.6,2216.6z  M1477.5,2953.4c-234-9.8-459.4-91-645.9-232.5l468.8-541.9c108.6,74.9,252.3,74.9,360.9,0l446.3,557.8 C1924.7,2872.1,1704.8,2947.7,1477.5,2953.4L1477.5,2953.4z M2114.1,2600l-180.9-225c79-77.9,136.8-174.7,167.8-281.2l264.4,122.8 C2314.6,2363.2,2228.3,2494.9,2114.1,2600L2114.1,2600z M2414.1,1977.5h-124.7v-123.8h124.7V1977.5z M2360.6,1617.5l-312.2,133.1 c-4.5,2.1-8.6,5-12.2,8.4h-83.4l390.9-170.6L2360.6,1617.5z M1748.4,1746.9c-16.3-25.8-36.2-49.2-59.1-69.4l669.4-281.2 c17.5-7.2,29-24.2,29.1-43.1v-77.8h70.3v162.2L1748.4,1746.9z"
});

var _ref11 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 1202.8,
  cy: 528.1,
  r: 54.4
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1125,875c55.9,0,101.2-45.3,101.2-101.2s-45.3-101.2-101.2-101.2s-101.2,45.3-101.2,101.2l0,0 C1023.8,829.7,1069.1,875,1125,875z M1125,765.3c4.1,0,7.5,3.4,7.5,7.5c0,8.4-15.9,8.4-15.9,0c0-4.1,3.3-7.5,7.4-7.6 C1124.3,765.3,1124.7,765.3,1125,765.3z"
});

var _ref13 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 1750.3,
  cy: 528.1,
  r: 54.4
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1727.8,773.8c0,55.9,45.3,101.2,101.2,101.2c55.9,0,101.2-45.3,101.2-101.2s-45.3-101.2-101.2-101.2l0,0 C1773.1,672.5,1727.8,717.8,1727.8,773.8z M1829.1,766.2c4.1,0,7.5,3.4,7.5,7.5c0,8.4-15.9,8.4-15.9,0c-0.6-4.1,2.3-7.9,6.4-8.4 c0.7-0.1,1.3-0.1,2,0V766.2z"
});

var SvgFalcon = function SvgFalcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Calque_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 3000 4000",
    enableBackground: "new 0 0 3000 4000",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgFalcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/falcon.ceeb2447.svg";
export { ForwardRef as ReactComponent };